export default "__VITE_ASSET__DaGe5MgR__"